import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceProviderService } from '../Service/Service-providers/service-provider.service';
import { ToastService } from '../Service/ToastService/toast.service';
import { FormStateService } from '../module/service-provider/add-sp-new-component/form-state.service';

// import { FormStateService } from '../services/formstate/form-stae-service.service';


@Component({
  selector: 'app-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['./otp-page.component.scss'],
})

export class OtpPageComponent implements OnInit {
  model: any = {
    phoneNumber: '',
    countryCode: '91', // Default to India's country code (numeric only)
    countryId: 1, // Default to India's countryId
    otp: '',
  resetPasswordToken: '',
  };
  // phoneNumber: string = '';
  // countryId: number = 1;
  // otpMessage: string = '';
  // otpCode: string = '';

  countryCodes: any[] = []; // Dynamically populated from API
  otpSent = false;
  otpInputs: string[] = Array(6).fill('');
  otpVerified = false;
  resendTimer: number = 0;
  resendInterval: any;
  role: string = '';
  showPasswordPopup: boolean = false;
  

  constructor(
    private spService: ServiceProviderService,
    private toastService: ToastService,
    private router: Router,
    private formstate: FormStateService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // this.role = this.formstate.getRole();
    // // localStorage.clear();
    // console.log('Environment:', environment);
    this.fetchCountries(); 
  }


  countryCodeMap: { [key: string]: string } = {
    India: 'IN',
    Oman: 'OM',
  };
  
  fetchCountries() {
    this.spService.getCountry('').subscribe({
      next: (response) => {
        this.countryCodes = response.map((country: any) => ({
          label: `${this.countryCodeMap[country.name] || country.name} (${country.countryCode})`,
          value: country.countryCode.replace('+', ''), 
          id: country.countryId,
        }));

        console.log('Fetched countries:', this.countryCodes);
      },
      error: (err) => {
        console.error('Error fetching countries:', err);
        this.toastService.showToast('Failed to load countries. Please try again.', 'error');
      },
    });
  }

  // Handle Phone Number Input
  handlePhoneNumberChange() {
    this.otpSent = false; // Reset OTP state when phone number changes
    this.model.otp = ''; // Clear the OTP field
    this.resetOtpState();
  }

  // Update countryId when countryCode changes
  updateCountryId() {
    const selectedCountry = this.countryCodes.find(
      (code) => code.value === this.model.countryCode
    );
    this.model.countryId = selectedCountry ? selectedCountry.id : 0;
  }

  // Send OTP logic
  sendOtp() {
    if (this.model.phoneNumber.length !== 10) {
      this.toastService.showToast('Please enter a valid 10-digit phone number.', 'error');
      return;
    }

    // Construct payload
    const { phoneNumber, countryId } = this.model;
    console.log('Sending OTP with payload:', phoneNumber, countryId);

      this.spService.requestOtp(phoneNumber, countryId).subscribe({
        next: (response) => {
          if (response.isSuccess) {
            this.otpSent = true;
            const otp = response.result.otp || '';
            const message = response.result.message || `Your OTP is: ${otp}`;
            this.toastService.showToast(
              'OTP has been sent to your registered mobile number.',
              'success'
            );
            this.startResendTimer();
            this.cdRef.detectChanges();
          } else {
            console.warn('OTP send failed:', response.errors);
          }
        },
        error: (error) => {
          console.error('Error sending OTP:', error);
        this.toastService.showToast('Failed to send OTP. Please try again.', 'error');
        this.resetOtpState();
        }
      });

  }

  
  resendOtp() {
    const payload: any = {
      phoneNumber: this.model.phoneNumber || '', 
      countryId: this.model.countryId, 
    };

    console.log('Resending OTP with payload:', payload);

    this.spService.resendPasswordOtp(payload).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          const otp = response.result.otp || '';
          const message = response.result.message || `Your OTP is: ${otp}`;
          this.toastService.showToast(
          'OTP has been sent to your registered mobile number.',
          'success'
        );
          this.startResendTimer();
        } else {
          this.toastService.showToast(response.errors.join(', '), 'error');
        }
      },
      error: (err) => {
        console.error('Error resending OTP:', err);
        this.toastService.showToast('Failed to resend OTP. Please try again.', 'error');
      },
    });
  }

  // Reset OTP State
  resetOtpState() {
    this.otpSent = false;
    this.resendTimer = 0; 
    if (this.resendInterval) {
      clearInterval(this.resendInterval); 
    }
    this.model.otp = ''; 
  }

  startResendTimer() {
    this.resendTimer = 30; 
    if (this.resendInterval) {
      clearInterval(this.resendInterval); 
    }

    this.resendInterval = setInterval(() => {
      this.resendTimer--;
      this.cdRef.detectChanges();
      if (this.resendTimer <= 0) {
        clearInterval(this.resendInterval); 
      }

    }, 1000); 
  }
  // OTP Change Handler
 onOtpChange(otp: string) {
  this.model.otp = otp;
  console.log('Current OTP:', otp);
  setTimeout(() => {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }, 0);
}
  // Check if OTP is Valid
  isOtpValid() {
    return this.model.otp?.trim().length === 6;
  }


  onVerify() {
    if (!this.isOtpValid()) {
      this.toastService.showToast('Please enter a valid OTP.', 'error');
      return;
    }
  
     const { phoneNumber, otp } = this.model;
     const payload = {
      phoneNumber: phoneNumber,
      otp: otp?.toString().trim(),
    };

    this.spService.verifyPasswordOtp(payload.phoneNumber, payload.otp).subscribe({
    next: (response) => {
      if (response.isSuccess) {
        this.otpVerified = true;
          // this.toastService.showToast(response.result.message, 'success');
        console.log('OTP verified successfully:', response.result);

       const resetToken = response.result.resetPasswordToken;
        localStorage.setItem('resetPasswordToken', resetToken);
        localStorage.setItem('verifiedPhoneNumber', response.result.phoneNumber);
        this.toastService.showToast('OTP verified successfully', 'success');
        this.otpSent = true;
        this.showPasswordPopup = true;
      } else {
        this.toastService.showToast(response.errors[0] || 'OTP verification failed.', 'error');
        this.toastService.showToast(response.errors.join(', '), 'error');
      }
    },
    error: (error) => {
      this.toastService.showToast('Error verifying OTP', 'error');
      console.error('OTP verification error:', error);
    }
  });
  
 
   }
  
  


}
